const isLocalPath = value => typeof value === "string" && value.startsWith("/") &&
  !value.startsWith("//") && !/[\\\u0000-\u001f\u007f]/.test(value);

function safePath(value, origin) {
  if (!isLocalPath(value)) return null;
  try {
    // Validate decoded and normalized forms too: browsers normalize dot segments,
    // and stripping the origin from /app/..//host must not produce //host.
    if (!isLocalPath(decodeURIComponent(value))) return null;
    const target = new URL(value, origin);
    if (target.origin !== new URL(origin).origin) return null;
    const relative = `${target.pathname}${target.search}${target.hash}`;
    return isLocalPath(relative) && isLocalPath(decodeURIComponent(relative)) ? relative : null;
  } catch {
    return null;
  }
}

export function loginDestination(role, candidates, origin) {
  for (const candidate of candidates) {
    const path = safePath(candidate, origin);
    if (path) return path;
  }
  return role === "admin" ? "/admin" : role === "driver" ? "/driver" : "/app";
}
